<mat-progress-bar mode="indeterminate" *ngIf="progressBarService.isShown$ | async"></mat-progress-bar>
